<template>
    <div class="footer">
        <div class="footer-a">
            <div class="footer-floor-1">
                <dl class="ylfw">
                    <dt>
                        <i></i>
                    </dt>
                    <dd>
                        <a class="title">医疗服务</a>
                        <a>一键查找对应服务</a>
                        <a>告别就医烦恼</a>
                    </dd>
                </dl>
                <dl class="qytg">
                    <dt>
                        <i></i>
                    </dt>
                    <dd>
                        <a class="title">区域推广</a>
                        <a>精准推送有效信息</a>
                        <a>个性化满足需求</a>
                    </dd>
                </dl>
                <dl class="qwtg">
                    <dt>
                        <i></i>
                    </dt>
                    <dd>
                        <a class="title">权威科普</a>
                        <a>汇聚权威科普资讯</a>
                        <a>最贴心健康顾问</a>
                    </dd>
                </dl>
                <dl class="ylfz">
                    <dt>
                        <i></i>
                    </dt>
                    <dd>
                        <a class="title">医疗辅助</a>
                        <a>匹配丰富产品工具</a>
                        <a>享受服务更便捷</a>
                    </dd>
                </dl>
            </div>
        </div>
        <div class="footer-b">
            <div class="left">
                <dl v-for="item in hotLink">
                    <dt>{{item.title}}</dt>
                    <dd>
                        <a v-for="list in item.children" :target="list.blank ? '_blank' : '_self'" v-if="list.href.length > 0"
                           :href="list.href">{{list.title}}</a>
                    </dd>
                </dl>
            </div>
            <div class="right">
                <p>万家为全国66个城市提供医疗相关服务 </p>
                <div class="hot-line">
                    <dl>
                        <dt><i></i></dt>
                        <dd>
                            <a>全国服务热线</a>
                            <a class="hot-number">400-931-6788</a>
                            <a class="hot-txt">全年无休9:00-20:00</a>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
        <div class="footer-c">
            <div class="footer-c-a">
                <span>合作伙伴</span>
                <a v-for="item in partner" href="javascript:;" @click="goOutPage(item.href)" :title="item.title"><img :class="item.className"
                                                                                      :src="item.imgUrl"></a>
            </div>
            <div class="friend-link" id="friend-link">
                <div class="friend-link-txt">
                    <a v-for="item in bottomLink" :href="returnHref(item.linkId)">{{item.linkTitle}}</a>
                </div>
                <p>　
                    <a target="_blank" style="color: #f70" href="https://beian.miit.gov.cn">粤ICP备16081915号</a>　
                    互联网药品信息服务资格证书　<a target="_blank" style="color: #f70" href="https://mall.pinganwj.com/resources/static/img/wjmall_cert.png">(粤)-经营性-2018-0080</a>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502002443" style="display:inline-block;text-decoration:none;height:20px;line-height:20px; margin-left: 10px;"><img src="../../../static/img/icon_police.png" style="float:left;"/><span style="margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44030502002443号</span></a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import url from './../../../config/url';
    import axios from 'axios';

    export default {
        data() {
            return {
                year: (new Date()).getFullYear(),
                hotLink: [
                    {
                        title: "入驻诊所国家",
                        children: [
                            {
                                title: "新加坡",
                                href: url.clinicRoot + "/login/register.do"
                            }, {
                                title: "日本",
                                href: url.clinicRoot + "/login/register.do"
                            }, {
                                title: "韩国",
                                href: url.clinicRoot + "/login/register.do"
                            }
                        ]
                    },
                    {
                        title: "为用户服务",
                        children: [
                            {
                                title: "找诊所",
                                href: url.commonRoot + "/clinic"
                            }, {
                                title: "找医生",
                                href: url.commonRoot + "/doctor"
                            }, {
                                title: "预约诊所",
                                href: url.commonRoot + "/clinic"
                            }, {
                                title: "预约医生",
                                href: url.commonRoot + "/doctor"
                            }, {
                                title: "找精品资讯",
                                href: url.commonRoot + "/health"
                            }, {
                                title: "找疾病百科",
                                href: url.commonRoot + "/disease"
                            }, {
                                title: "找药品百科",
                                href: url.commonRoot + "/knowledge/sou"
                            }, {
                                title: "找职位",
                                href: url.hyqtRoot + "/security/jobListPage/jobList.w"
                            }
                        ]
                    },
                    {
                        title: "为诊所赋能",
                        children: [
                            {
                                title: "加盟万家",
                                href: url.clinicRoot + "/login/register.do"
                            }, {
                                title: "权威认证",
                                href: url.clinicRoot + "/index/getHomeCaseModel.do?caseModel=wjrz"
                            }, {
                                title: "云诊所",
                                href: url.commonRoot + "/cloudclinic"
                            }, {
                                title: "万家学院",
                                href: url.college
                            }, {
                                title: "万家人才",
                                href: url.clinicRoot + "/index/getHomeCaseModel.do?caseModel=wjrc"
                            }
                        ]
                    },
                    {
                        title: "移动万家",
                        children: [
                            {
                                title: "移动诊所",
                                href: url.commonRoot + "/appDownload?tab=app"
                            }, {
                                title: "微信万家",
                                href: url.commonRoot + "/appDownload?tab=webChat"
                            }
                        ]
                    },
                    {
                        title: "更多",
                        children: [
                            {
                                title: "网站导航",
                                href: ""
                            }, {
                                title: "帮助中心",
                                href: url.commonRoot + "/help"
                            }, {
                                title: "问题反馈",
                                href: url.commonRoot + "/sso/feedback?feedbackSource=6",
                                blank: true
                            }
                        ]
                    }
                ],
                partner: [
                    {
                        href: "http://health.pingan.com/",
                        title: "平安健康险",
                        className: "brand-1",
                        imgUrl: url.static + "/img/brand-jkx.png"
                    },
                    {
                        href: "http://one.pingan.com/index.jsp",
                        title: "平安一账通",
                        className: "brand-2",
                        imgUrl: url.static + "/img/brand-yzt.png"
                    },
                    {
                        href: "https://www.yqb.com/",
                        title: "壹钱包",
                        className: "brand-3",
                        imgUrl: url.static + "/img/brand-yiqianbao.png"
                    },
                    {
                        href: "http://annuity.pingan.com/",
                        title: "平安养老险",
                        className: "brand-4",
                        imgUrl: url.static + "/img/brand-ylx.png"
                    },
                    {
                        href: "http://www.baikemy.com/",
                        title: "百科名医",
                        className: "brand-5",
                        imgUrl: url.static + "/img/brand-bkmz.png"
                    },
                    /*{
                        href: "",
                        title: "",
                        className: "brand-6",
                        imgUrl: url.static + "/img/brand-ieem.jpg"
                    },*/
                    {
                        href: "http://bank.pingan.com/",
                        title: "平安银行",
                        className: "brand-7",
                        imgUrl: url.static + "/img/brand-brank.png"
                    },
                ],
                bottomLink: []
            }
        },
        created: function () {
            this.getAboutLink();
        },
        mounted: function () {
            var _this = this
            $("#friend-link").scrollLoading({
                callback: function () {
                    _this.getAboutLink();
                }
            });
        },
        methods: {
            goOutPage(href){
                this.$Modal.confirm({
                    content: '<span style="font-size: 14px;">您将跳出云诊系统，是否继续？</span>',
                    onOk: () => {
                         window.open(href);
                    },
                    onCancel: () => {
                    }
                });
            },
            returnHref(id) {
                return url.commonRoot + "/about/" + id;
            },
            //获取关于万家
            getAboutLink() {
                var _this = this;
                axios.get(url.getAboutLink).then(function (res) {
                    if (res.data.result != null) {
                        _this.bottomLink = res.data.result;
                    }
                }).catch(function (error) {
                    _this.$Message.error('数据获取失败,请稍后再试！');
                });
            },
        }
    }
</script>
<style scoped lang="scss">
    @import "../../../static/scss/page/footerBar";
</style>
<style scoped>
    .ivu-modal-confirm-body-icon-confirm{
        background: #ff8e42;
    }
</style>


// WEBPACK FOOTER //
// src/components/Common/footerBar.vue